module.exports = __webpack_public_path__ + "img/bg-corkboard.bd737677.jpg";